import * as React from 'react'
import { Button, Col, Form, Input, Row, Select } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { Controller, useForm } from 'react-hook-form'

import { WALLET_NETWORKS } from '../../config'
import { AddressCheckFormData, AddressCheckFormProps } from './types'

export const AddressCheckForm: React.FC<AddressCheckFormProps> = ({
  defaultValues,
  onSubmit,
  loading,
}) => {
  const { handleSubmit, control } = useForm<AddressCheckFormData>({
    mode: 'onChange',
    defaultValues: {
      network: undefined,
      walletAddress: '',
      ...defaultValues,
    },
  })

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Row gutter={16}>
        <Col xs={24} md={6}>
          <Controller
            name="network"
            control={control}
            rules={{ required: 'Выберите сеть' }}
            render={({ field, fieldState: { error } }) => (
              <Form.Item
                label="Сеть"
                validateStatus={error ? 'error' : undefined}
                help={error?.message}
              >
                <Select
                  {...field}
                  placeholder="Выберите сеть"
                  options={WALLET_NETWORKS.map((value) => ({
                    value,
                    label: value,
                  }))}
                />
              </Form.Item>
            )}
          />
        </Col>
        <Col xs={24} md={18}>
          <Controller
            name="walletAddress"
            control={control}
            rules={{
              validate: (value) =>
                value.trim() !== '' || 'Укажите адрес кошелька',
            }}
            render={({ field, fieldState: { error } }) => (
              <Form.Item
                label="Адрес кошелька"
                validateStatus={error ? 'error' : undefined}
                help={error?.message}
              >
                <Input
                  {...field}
                  placeholder="TXxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
                />
              </Form.Item>
            )}
          />
        </Col>
      </Row>

      <Button
        type="primary"
        htmlType="submit"
        icon={<SearchOutlined />}
        disabled={loading}
        loading={loading}
      >
        Проверить адрес
      </Button>
    </form>
  )
}
